import clsx from 'clsx'
import { KTIcon } from '../../../helpers'
import { HeaderUserMenu, ThemeModeSwitcher } from '../../../partials'
import { useLayout } from '../../core'
import { useAuth } from '../../../../app/modules/auth'

const itemClass = 'ms-1 ms-lg-3'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'fs-1'

const Navbar = () => {
  const { config } = useLayout()
  const { currentUser, auth } = useAuth()
  const companyLogo = auth?.empresa?.s_logo_url
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <div className='symbol symbol-circle symbol-50px overflow-hidden me-3 border-2 border bg-gray-500'>
            <div
              className={clsx(
                'symbol-label fs-3',
              )}
            >
              {companyLogo ? (
                <img src={companyLogo} alt='Logo' className='h-40px h-lg-50px overflow-hidden' />
              ) : currentUser?.s_nome?.split("")?.[0]}
            </div>
          </div>
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export { Navbar }
